import React, { useEffect, useState } from "react";
import firebase from "firebase";
import Wrapper from "../Layout/Wrapper";
import StarBackground from "../../assets/star-background.png";
import Earth from "../../assets/earth.svg";
import "./index.css";
import { Student } from "../../types";

const Header = () => {
  const [username, setUsername] = useState("");
  const { currentUser } = firebase.auth();
  useEffect(() => {
    const getStudent = async () => {
      if (!currentUser) {
        return { name: "" };
      }
      const student = await firebase
        .firestore()
        .collection("students")
        .where("uid", "==", currentUser?.uid)
        .get();
      if (!student.empty) {
        return student.docs[0].data() as Student;
      }

      const admin = await firebase
        .firestore()
        .collection("administrators")
        .doc(currentUser?.uid)
        .get();

      return admin.data() as Student;
    };
    getStudent().then((student) => {
      setUsername(student?.name);
    });
  }, [currentUser]);

  return (
    <header
      style={{
        backgroundImage: `url('${StarBackground}')`,
        height: 268,
      }}
    >
      <Wrapper style={{ alignItems: "center" }}>
        <img src={Earth} alt="earn" />
        <h1 style={{ marginLeft: 64 }}>Hello, {username}! </h1>
      </Wrapper>
    </header>
  );
};

export default Header;
